import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import Service from '../../Service/Service';
import Api from '../../api';

export const SummaryList = ({ organization, filters }) => {
  const [summaryServices, setSummaryServices] = useState<Service[] | null>(null);

  useEffect(() => {
    Api.summaryServices({ hash: organization.hash, ...filters }).then((r) => {
      setSummaryServices(r);
    });
  }, [organization, filters]);

  if (!summaryServices?.length) return null;

  const isAssociation = organization?.type === 'association';

  return (
    <div className="summary-list-container">
      <div className="summary-list-title">Recently Added</div>
      {summaryServices.map((service) => {
        const baseUrl = isAssociation ? service?.organization?.embed_url : organization?.embed_url;
        const serviceUrl = baseUrl ? baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'funeral=' + service?.hash : null;

        return (
          <div className="summary-service-container" key={service.hash}>
            <div className="summary-name">
              {service.summaryName?.map((formatted) =>
                formatted?.key ? (
                  <span key={formatted?.key} className={'summary-title-' + formatted?.key}>
                    {formatted?.text}
                  </span>
                ) : null,
              )}
            </div>

            <div className="flex items-center justify-between gap-8">
              {isAssociation && <img className="h-12 object-contain" src={service.organization.logo_url} alt={service.organization.name} />}
              {serviceUrl ? (
                <a className="summary-service-right-side" href={serviceUrl}>
                  <span className="summary-service-view-details">View Details</span>
                  <ChevronRightIcon className="summary-service-chevron" />
                </a>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};
